export default __webpack_public_path__ + "static/media/verify-letter.16643c4f.svg";